import React, { useEffect, useState, forwardRef, Fragment } from 'react'
import * as yup from "yup"
import { yupResolver } from "@hookform/resolvers/yup"
import { useDispatch, useSelector } from 'react-redux'
import { getWoLoading, GetVessels, CreateVessel } from '../redux/store'
import { Input, Label, Row, Col, Button, TabContent, TabPane, Modal, ModalHeader, ModalBody, ModalFooter, Spinner, Form, FormFeedback } from 'reactstrap'
import ComponentSpinner from '../../components/spinner/Loading-spinner'
import LoadingOpaqueSpinner from '../../components/spinner/Loading-opaque-spinner'
import DefaultSettings from '../../settings/pageSettings'
import { DefaultConfig } from '../../settings/config'
import '@styles/react/libs/tables/react-dataTable-component.scss'
import ReactPaginate from 'react-paginate'
import DataTable from 'react-data-table-component'
import { ChevronDown, ChevronUp, X, RefreshCcw, Plus } from 'react-feather'
import CustomValueContainer from "../Components/Select"
import Select, { components } from 'react-select'
import { veselListColumns } from "./VeselData"
import { useNavigate } from 'react-router-dom'
import classnames from 'classnames'
import Sidebar from '../Components/SideBar'
import toast from 'react-hot-toast'
import ToastMessage from '../../components/toast-messages'
import { useForm, Controller } from 'react-hook-form'

const VeselList = () => {
  const dispatch = useDispatch()
  const [currentPage, setCurrentPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(DefaultSettings.perPage)
  const selectStyles = DefaultConfig().selectStyles
  const navigate = useNavigate()

  const stores = useSelector((state) => state.commonreducerSlice)
  // const isEmployee = isUserLoggedIn() && JSON.parse(isUserLoggedIn()).isEmployee
  const [id, setId] = useState(null)
  const [idEnterKey, setIdEnterKey] = useState([])

  const [name, setName] = useState("")
  const [nameEnterKey, setNameEnterKey] = useState([])

  const [vesselId, setVeselId] = useState("")
  const [vesselIdKey, setVeselIdEnterKey] = useState([])

  const [imoNumber, setImoNumber] = useState("")
  const [imoEnterKey, setImoEnterKey] = useState([])

  const [officialNumber, setOfficialNumber] = useState("")
  const [officailNumEnterKey, setOfficialNumEnterKey] = useState([])

  const [woData, setWoData] = useState([])
  const [sortName, setSortName] = useState("Id")
  const [sortOrder, setSortOrder] = useState("asc")
  const [displaytableData, setDisplaytableData] = useState(false)
  const [show, setShow] = useState(false)

  const [status, setStatus] = useState(3)
  const [disabling, setDisabling] = useState(false)

  const options = [
    { value: 'All', label: 'All', id: 3 },
    { value: 'Active', label: 'Active', id: 1 },
    { value: 'InActive', label: 'InActive', id: 2 }

  ]
  const [statusOption, setStatusOption] = useState(options[0])

  function loadingData(responseData) {
    const woDataObj = []
    if (stores.spinner3 && responseData.length > 0) {

      for (let i = 0; i < responseData.length; i++) {
        const element = { ...responseData[i] }
        woDataObj[i] = element
      }
    }
    setWoData(woDataObj)
    setDisplaytableData(false)
    setTimeout(() => {
      sessionStorage.removeItem('pageTransition')
    }, 1000)
  }

  const handleFilterData = (name, vesselId, imoNumber, officialNumber, sortName, sortOrder) => {
    dispatch(getWoLoading(false))
    setDisplaytableData(true)
    setCurrentPage(0)
    const obj = {}
    if (true) {
      obj.name = name
      if (vesselId?.length) {
        obj.vesselId = Number(vesselId)
      }
      if (imoNumber?.length) {
        obj.imonumber = imoNumber
      }
      if (officialNumber?.length) {
        obj.officialNumber = officialNumber
      }
    }
    obj.pageIndex = 1
    obj.pageSize = rowsPerPage
    obj.sortName = sortName
    obj.sortOrder = sortOrder
    // if (status !== 3) {
    //   obj.status = status
    // }
    async function fetchData(data) {
      if (true) {
        const responseData = await dispatch(GetVessels(obj))
        if (responseData.payload) {
          loadingData(responseData.payload.data)
        } else {
          setDisplaytableData(false)
        }
      }
    }
    fetchData(obj)
  }

  const customStyles = {
    rows: {
      style: {
        backgroundColor: '#f9f9f9'
      }
    }
  }

  const handleIdKeyDown = (event) => {
    if (event.key === 'Enter') {
      setIdEnterKey('Enter')
      if (event.target.value) {
        handleFilterData(name, vesselId, imoNumber, officialNumber, event.target.value, sortName, sortOrder)
      }
    }
  }

  function handleIdBlur() {
    if (id && idEnterKey !== 'Enter') {
      setTimeout(() => {
        handleFilterData(id, name, vesselId, imoNumber, officialNumber, sortName, sortOrder)
      }, 100)

    }
  }

  const handleNameKeyDown = (event) => {
    if (event.key === 'Enter') {
      setNameEnterKey('Enter')
      if (event.target.value?.length > 0) {
        handleFilterData(event.target.value, vesselId, imoNumber, officialNumber, sortName, sortOrder)
      }
    }
  }

  const handleNameBlur = () => {
    if (name.length > 0 && nameEnterKey !== 'Enter') {
      setTimeout(() => {
        handleFilterData(name, vesselId, imoNumber, officialNumber, sortName, sortOrder)
      }, 100)
    }
  }

  const handleVeselIdKeyDown = (event) => {
    if (event.key === 'Enter') {
      setVeselIdEnterKey('Enter')
      if (event.target.value?.length > 0) {
        handleFilterData(name, event.target.value, imoNumber, officialNumber, sortName, sortOrder)
      }
    }
  }

  const handleVeselIdBlur = () => {
    if (vesselId.length > 0 && vesselIdKey !== 'Enter') {
      setTimeout(() => {
        handleFilterData(name, vesselId, imoNumber, officialNumber, sortName, sortOrder)
      }, 100)
    }
  }

  const handleImoNumKeyDown = (event) => {

    if (event.key === 'Enter') {
      setImoEnterKey('Enter')
      if (event.target.value?.length > 0) {
        handleFilterData(name, vesselId, event.target.value, officialNumber, sortName, sortOrder)
      }
    }
  }

  const handleImoNumBlur = () => {
    if (imoNumber.length > 0 && imoEnterKey !== 'Enter') {
      setTimeout(() => {
        handleFilterData(name, vesselId, imoNumber, officialNumber, sortName, sortOrder)
      }, 100)
    }
  }

  const handleOfficialNumKeyDown = (event) => {

    if (event.key === 'Enter') {
      setOfficialNumEnterKey('Enter')
      if (event.target.value?.length > 0) {
        handleFilterData(name, vesselId, imoNumber, event.target.value, sortName, sortOrder)
      }
    }
  }

  const handleOfficialNumBlur = () => {
    if (officialNumber.length > 0 && officailNumEnterKey !== 'Enter') {
      setTimeout(() => {
        handleFilterData(name, vesselId, imoNumber, officialNumber, sortName, sortOrder)
      }, 100)
    }
  }

  const handleRowClick = (row) => {
    navigate(`/veselUser/${row.id}`)
  }

  // const clearFiltersSearch = () => {
  //   setName("")
  //   setAgentId("")
  //   setSfUniqueId("")
  //   setId(null)
  //   setStatus(3)
  //   setRegion("")
  //   setRegionalOption(null)
  //   setStatusOption(options[0])
  //   handleFilterData("", "", "", null, "", sortName, sortOrder, 3, null)
  // }

  useEffect(() => {
    setTimeout(() => {
      handleFilterData(name, vesselId, imoNumber, officialNumber, sortName, sortOrder)
    }, 100)
  }, [rowsPerPage, sortOrder])

  const handlePagination = async (page) => {
    setDisplaytableData(true)
    setCurrentPage(page.selected)
    dispatch(getWoLoading(false))
    const obj = {}
    if (true) {
      obj.name = name
      if (vesselId?.length) {
        obj.vesselId = vesselId
      }
      if (imoNumber?.length) {
        obj.imonumber = imoNumber
      }
      if (officialNumber?.length) {
        obj.officialNumber = officialNumber
      }
    }
    // if (status !== 3) {
    //   obj.status = status
    // }
    obj.pageIndex = (page.selected + 1)
    obj.pageSize = rowsPerPage
    obj.sortOrder = sortOrder
    obj.sortName = sortName

    const responseData = await dispatch(GetVessels(obj))
    if (responseData.payload) {

      loadingData(responseData.payload.data)
    } else {
      setDisplaytableData(false)
    }
  }

  const handlePerPage = (e) => {
    const value = parseInt(e.currentTarget.value)
    setRowsPerPage(value)
    setCurrentPage(0)
  }

  const CustomPagination = () => (
    <Row className="my-0 mx-0 workorder_pagination_row all_pagination_row">
      <Col sm="12" md="4" lg="3" xl="4" className="d-flex align-items-center p-0 showingEntries ">
        <Label className='mb-0 font-weight-bold showing_panel'>
          Showing {(((currentPage) * stores.gridSize) + 1)} to {(Math.ceil(stores.recCount / (stores.gridSize)) || 1) !== (currentPage + 1) ? ((((currentPage) * stores.gridSize) + 1) + (stores.gridSize - 1)) : stores.recCount} of {stores.recCount} entries
        </Label>
      </Col>
      <Col sm="12" md="8" lg="9" xl="8"
        className="d-flex align-items-sm-center justify-content-lg-end justify-content-md-end justify-content-start flex-lg-nowrap flex-wrap flex-sm-row flex-column p-0 contentAligment"
      >
        <div className="d-flex align-items-center me-1" style={{ marginTop: "7px" }}>
          <Label for="rows-per-page font-weight-bold  " className={"form-label1"}>Rows per page: </Label>
          <Input
            className="form-control mx-50 "
            type="select"
            id="rows-per-page"
            value={rowsPerPage}
            onChange={handlePerPage}
            style={{
              width: "5rem",
              padding: "0 0.8rem",
              backgroundPosition: "calc(100% - 3px) 4px, calc(100% - 20px) 13px, 100% 0"
            }}
          >
            {DefaultSettings?.pagination.map((count, index) => {
              return (
                <option value={count.value} key={index.toString()}>
                  {count.label}
                </option>
              )
            })}
          </Input>
        </div>
        <ReactPaginate
          previousLabel={''}
          nextLabel={''}
          forcePage={currentPage}
          onPageChange={page => handlePagination(page)}
          pageCount={Math.ceil(stores.recCount / (stores.gridSize)) || 1}
          breakLabel={'...'}
          pageRangeDisplayed={5}
          marginPagesDisplayed={5}
          activeClassName='active'
          pageClassName='page-item'
          breakClassName='page-item'
          nextLinkClassName='page-link'
          pageLinkClassName='page-link'
          breakLinkClassName='page-link'
          previousLinkClassName='page-link'
          nextClassName='page-item next-item'
          previousClassName='page-item prev-item'
          containerClassName={'pagination react-paginate separated-pagination pagination-sm justify-content-end workorder_pagination_view'}
        />
      </Col>
    </Row>
  )

  const handleSort = (column) => {
    setSortName(column.sortName)
    const sortingorder = sortOrder
    if (sortingorder === '') {
      setSortOrder('asc')
    } else if (sortingorder === 'asc') {
      setSortOrder('desc')
    } else if (sortingorder === 'desc') {
      setSortOrder('asc')
    }
  }

  const [mspinnerStatus, setMSpinnerStatus] = useState(false)
  const [newVesselId, setNewVeselId] = useState()
  const [newVesselName, setNewVesselName] = useState("")
  const [newImoNumber, setNewImoNumber] = useState()
  const [newOfficialNumber, setNewOfficialNumber] = useState()

  const ValidSchema = yup.object().shape({
    [`newVesselId`]: yup.string().nullable().required("vessel Id is a required field"),
    [`newVesselName`]: yup.string().nullable().required("Last Name is a required field"),
    [`newImoNumber`]: yup.string().nullable().required("Imo number is a required"),
    [`newOfficialNumber`]: yup.string().nullable().required(" Official Number  is a required")

  })

  const { trigger, handleSubmit, control, reset, setValue, formState: { errors } } = useForm({ mode: 'onChange', resolver: yupResolver(ValidSchema) })

  const handleReset = () => {
    reset({
      newVesselId: null,
      newVesselName: null,
      newImoNumber: null,
      newOfficialNumber: null
    })
    setNewVeselId("")
    setNewVesselName("")
    setNewImoNumber("")
    setNewOfficialNumber("")
    setDisabling(false)
  }

  const toggleSidebar = () => {
    handleReset()
    setShow(false)
  }
  const onSubmit = async () => {
    trigger()
    if (Object.keys(errors).length === 0) {
      const obj = {}
      obj.vesselId = newVesselId
      obj.name = newVesselName
      obj.imonumber = newImoNumber
      obj.officialNumber = newOfficialNumber
      async function fetch1() {
        setMSpinnerStatus(true)
        const response = await dispatch(CreateVessel(obj)).finally(() => {
          setMSpinnerStatus(false)
        })
        console.log(response, "res")
        if (response.payload) {
          // fetch(userStatus.id, addressStatus)
          setShow(false)
          reset()
        }
      }
      fetch1()
    }
  }

  return (
    <>
      <Sidebar
        size="sm"
        open={show}
        title={`Add Vessel `}
        headerClassName="mb-1"
        contentClassName="pt-0"
        toggleSidebar={toggleSidebar}

      >
        {(show) ? (<>
          <Form onSubmit={handleSubmit(onSubmit)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault()
              }
            }}
            style={{ margin: '0 0' }}>
            <ModalBody style={{ paddingLeft: '10px', paddingRight: '10px', paddingTop: '20px' }}>
              <Row>

                <Col sm='12' md='12' lg='12' xl='12'>
                  <div className='mt-2 input-wrapper'>
                    <Controller
                      defaultValue=''
                      control={control}
                      type="text"
                      id='newVesselId'
                      name='newVesselId'
                      render={({ field: { onChange } }) => <Input
                        placeholder=''
                        invalid={errors.newVesselId && true}
                        value={newVesselId}
                        onChange={(val) => {
                          const numericValue = val.target.value.replace(/\D/g, '')
                          onChange(numericValue)
                          setNewVeselId(numericValue)
                        }}
                      />}
                    />
                    <Label className='form-label' for={`newVesselId`}>
                      New Vessel Id
                    </Label>
                    {errors.newVesselId && <FormFeedback>{errors.newVesselId.message}</FormFeedback>}
                  </div>
                </Col>
                <Col sm='12' md='12' lg='12' xl='12'>
                  <div className='mt-2 input-wrapper'>
                    <Controller
                      defaultValue=''
                      control={control}
                      type="text"
                      id='newVesselName'
                      name='newVesselName'
                      render={({ field: { onChange } }) => <Input
                        placeholder=''
                        invalid={errors.newVesselName && true}
                        value={newVesselName}
                        onChange={(val) => {
                          onChange(val, setNewVesselName(val.target.value))
                        }}
                      />}
                    />
                    <Label className='form-label' for={`newVesselName`}>
                      New Vessel Name
                    </Label>
                    {errors.newVesselName && <FormFeedback>{errors.newVesselName.message}</FormFeedback>}
                  </div>
                </Col>
                <Col sm='12' md='12' lg='12' xl='12'>
                  <div className='mt-2 input-wrapper'>
                    <Controller
                      defaultValue=''
                      control={control}
                      type="text"
                      id='newImoNumber'
                      name='newImoNumber'
                      render={({ field: { onChange } }) => <Input
                        placeholder=''
                        invalid={errors.newImoNumber && true}
                        value={newImoNumber}
                        onChange={(val) => {
                          const numericValue = val.target.value.replace(/\D/g, '')
                          onChange(numericValue)
                          setNewImoNumber(numericValue)
                        }}
                      />}
                    />
                    <Label className='form-label' for={`newImoNumber`}>
                      New IMO Number
                    </Label>
                    {errors.newImoNumber && <FormFeedback>{errors.newImoNumber.message}</FormFeedback>}
                  </div>
                </Col>
                <Col sm='12' md='12' lg='12' xl='12'>
                  <div className='mt-2 input-wrapper'>
                    <Controller
                      defaultValue=''
                      control={control}
                      type="text"
                      id='newOfficialNumber'
                      name='newOfficialNumber'
                      render={({ field: { onChange } }) => <Input
                        placeholder=''
                        invalid={errors.newOfficialNumber && true}
                        value={newOfficialNumber}
                        onChange={(val) => {
                          const numericValue = val.target.value.replace(/\D/g, '')
                          onChange(numericValue)
                          setNewOfficialNumber(numericValue)
                        }}
                      />}
                    />
                    <Label className='form-label' for={`newOfficialNumber`}>
                      New Official Number
                    </Label>
                    {errors.newOfficialNumber && <FormFeedback>{errors.newOfficialNumber.message}</FormFeedback>}
                  </div>
                </Col>

              </Row>
            </ModalBody>

            <ModalFooter className='p-0 d-block' style={{ border: 0, marginTop: '30px' }}>
              <Row>
                <Col sm='12' md='12' lg='12' xl='12' className='p-0 mt-1'>
                  <div className='model_popup_panel model_popup_submit_btn model_popup_footer_fixed' style={{ justifyContent: 'center', padding: "12px 0px", display: "flex", background: "unset" }}>
                    {mspinnerStatus ? (
                      <Button.Ripple color='primary' disabled={mspinnerStatus}>
                        <Spinner size='sm' />
                        <span className='mx-50'>Loading...</span>
                      </Button.Ripple>
                    ) : (
                      <Fragment>
                        <Button className='me-1 reset_button_view' outline color='secondary' onClick={handleReset}>
                          <RefreshCcw size={14} className='align-middle me-sm-25 me-0' />
                          <span className='align-middle d-sm-inline-block mx-50'>Reset</span>
                        </Button>
                        <Button className='create_submit_btn' type='submit'>
                          <span className='align-middle d-sm-inline-block mx-50'>{'Add Vessel'}</span>
                        </Button>
                      </Fragment>
                    )}
                  </div>
                </Col>
              </Row>
            </ModalFooter>
          </Form></>) : (
          <ComponentSpinner />
        )}
      </Sidebar>

      <Row className="billing-sec" style={{ margin: "0px" }}>
        <div className='filter_bill mb-1'>Filter By:</div>
        <Row className="">
          <Col md="4" lg="3" xl="3" sm="12" className='mb-1 filter-padding d-none'>
            <div className='input-wrapper'>
              <Input id='invoiceNum'
                type="text"
                placeholder=''
                value={id}
                onBlur={handleIdBlur}
                onChange={(e) => {
                  if (!isNaN(e.target.value)) {
                    setId(Number(e.target.value))
                    setIdEnterKey('')
                  }
                  if (!e.target.value) {
                    handleFilterData("", name, vesselId, imoNumber, officialNumber, sortOrder, status)
                  }
                }}
                onKeyDown={handleIdKeyDown}
                autoComplete="off"
              />
              <Label className='form-label input_label' for='invoiceNum'>ID</Label>
              {id &&
                <div onClick={() => {
                  setId(null)
                  setIdEnterKey('')
                  handleFilterData("", name, vesselId, imoNumber, officialNumber, sortOrder, status)
                }} className='clear-icon'>
                  <X size={16} strokeWidth={3} />
                </div>
              }
            </div>

          </Col>
          <Col md="4" lg="3" xl="3" sm="12" className='mb-1 filter-padding'>
            <div className='input-wrapper'>
              <Input id='invoiceNum'
                type="text"
                placeholder=''
                value={name}
                onBlur={handleNameBlur}
                onChange={(e) => {
                  setName(e.target.value)
                  setNameEnterKey('')
                  if (!e.target.value) {
                    handleFilterData("", vesselId, imoNumber, officialNumber, sortName, sortOrder, status)
                  }
                }}
                onKeyDown={handleNameKeyDown}
                autoComplete="off"
              />
              <Label className='form-label input_label' for='invoiceNum'>Vessel Name</Label>
              {name &&
                <div onClick={() => {
                  setName('')
                  setNameEnterKey('')
                  handleFilterData('', vesselId, imoNumber, officialNumber, sortName, sortOrder, status)
                }} className='clear-icon'>
                  <X size={16} strokeWidth={3} />
                </div>
              }
            </div>

          </Col>
          <Col md="4" lg="3" xl="3" sm="12" className='mb-1 filter-padding'>
            <div className='input-wrapper'>
              <Input id='invoiceNum'
                type="text"
                placeholder=''
                value={vesselId}
                onBlur={handleVeselIdBlur}
                onChange={(e) => {
                  if (!isNaN(e.target.value)) {
                    setVeselId(e.target.value)
                  }
                  if (!e.target.value) {
                    handleFilterData(name, "", imoNumber, officialNumber, sortName, sortOrder, status)
                  }
                  setVeselIdEnterKey('')
                }}
                onKeyDown={handleVeselIdKeyDown}
                autoComplete="off"
              />
              <Label className='form-label input_label' for='invoiceNum'>Vessel ID</Label>
              {vesselId &&
                <div onClick={() => {
                  setVeselId('')
                  setVeselIdEnterKey('')
                  handleFilterData(name, "", imoNumber, officialNumber, sortName, sortOrder, status)
                }} className='clear-icon'>
                  <X size={16} strokeWidth={3} />
                </div>
              }
            </div>
          </Col>
          <Col md="4" lg="3" xl="3" sm="12" className='mb-1 filter-padding'>
            <div className='input-wrapper'>
              <Input id='invoiceNum'
                type="text"
                placeholder=''
                value={imoNumber}
                onBlur={handleImoNumBlur}
                onChange={(e) => {
                  if (!isNaN(e.target.value)) {
                    setImoNumber(e.target.value)
                  }
                  setImoEnterKey('')
                  if (!e.target.value) {
                    handleFilterData(name, vesselId, "", officialNumber, sortName, sortOrder, status)
                  }
                }}
                onKeyDown={handleImoNumKeyDown}
                autoComplete="off"
              />
              <Label className='form-label input_label' for='invoiceNum'>IMO Number</Label>
              {imoNumber &&
                <div onClick={() => {
                  setImoNumber('')
                  setImoEnterKey('')
                  handleFilterData(name, vesselId, "", officialNumber, sortName, sortOrder, status)
                }} className='clear-icon'>
                  <X size={16} strokeWidth={3} />
                </div>
              }
            </div>

          </Col>
          <Col md="4" lg="3" xl="3" sm="12" className='mb-1 filter-padding'>
            <div className='input-wrapper'>
              <Input id='invoiceNum'
                type="text"
                placeholder=''
                value={officialNumber}
                onBlur={handleOfficialNumBlur}
                onChange={(e) => {
                  if (!isNaN(e.target.value)) {
                    setOfficialNumber(e.target.value)
                  }
                  setOfficialNumEnterKey('')
                  if (!e.target.value) {
                    handleFilterData(name, vesselId, imoNumber, "", sortName, sortOrder, status)
                  }
                }}
                onKeyDown={handleOfficialNumKeyDown}
                autoComplete="off"
              />
              <Label className='form-label input_label' for='invoiceNum'>Official Number</Label>
              {officialNumber &&
                <div onClick={() => {
                  setOfficialNumber('')
                  setOfficialNumEnterKey('')
                  handleFilterData(name, vesselId, imoNumber, "", sortName, sortOrder, status)
                }} className='clear-icon'>
                  <X size={16} strokeWidth={3} />
                </div>
              }
            </div>

          </Col>

          <Col sm='12' md='4' lg='3' xl='3' className="mb-1 filter-padding">
            <div>
              <Select
                classNamePrefix="select"
                options={options}
                value={statusOption}
                onChange={(val) => {
                  setStatusOption(val)
                  if (val?.id) {
                    setStatus(val?.id)
                  }
                  handleFilterData(name, vesselId, imoNumber, officialNumber, sortName, sortOrder, val?.id)
                }}
                className={classnames('react-select')}
                placeholder={`Select Status`}
                styles={selectStyles}
                components={{ ValueContainer: CustomValueContainer }}
              />
            </div>
          </Col>

          <Col sm='12' md='4' lg='3' xl='3' className="mb-1 filter-padding">

            {/* <Button color='primary' className='btn-prev mr-2'
              onClick={() => setShow(true)}
             style={{ width: '116px' }}
            >
              <Plus size={14} className='' />
              <span className='align-middle d-sm-inline-block mx-50'>Create Vessel</span>
            </Button> */}
          </Col>

        </Row>

        <Col lg='12' md='12'>
          {(stores.spinner3 && !displaytableData) ? (
            <TabContent className="custom-tab-content">
              <div className={woData.length > 0 ? 'react-dataTable react_main_warpper_table' : 'react-dataTable react_main_warpper_table rdt_Table_Height'}>
                <TabPane>
                  <DataTable
                    noHeader
                    pagination
                    columns={veselListColumns(handleRowClick)}
                    paginationPerPage={stores.gridSize}
                    className='react-dataTable react_main_sub_warpper bill-data-table-container'
                    sortIcon={sortOrder === 'asc' ? <ChevronUp size={10} /> : <ChevronDown size={10} />}
                    paginationDefaultPage={currentPage + 1}
                    paginationComponent={CustomPagination}
                    data={woData.length ? woData : []}
                    noDataComponent={woData.length === 0 && 'There are no records to display'}
                    fixedColumns
                    onSort={handleSort}
                    onRowClicked={handleRowClick}
                    highlightOnHover
                    customStyles={customStyles}

                    pointerOnHover
                  />
                </TabPane>
              </div>
            </TabContent>
          ) : (
            <ComponentSpinner />
          )}
        </Col>
      </Row >

    </>

  )
}

export default VeselList